import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import OverviewSection from './components/OverviewSection';
import FeaturesSection from './components/FeaturesSection';
import NewsBanner from './components/NewsBanner';
import FooterSection from './components/FooterSection';

const AILandingPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState('overview');
  const featuresRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();

  // اسکرول به قابلیت‌ها اگر از مسیر دیگه اومده باشیم
  useEffect(() => {
    if (location.state?.scrollTo === 'features' && featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth' });
      setSelectedTab('features');
    }
  }, [location]);

  const handleTabChange = (tab: string) => {
    setSelectedTab(tab);
    if (tab === 'features' && featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen text-white bg-black">
      <Header selectedTab={selectedTab} onTabChange={handleTabChange} />
      <div className="pt-24"> {/* فاصله از بالا برای اینکه زیر هدر نیفته */}
        <NewsBanner />
        <OverviewSection />
        <div ref={featuresRef}>
          <FeaturesSection />
        </div>
        <FooterSection />
      </div>
    </div>
  );
};

export default AILandingPage;
